import React from 'react';
import 'react-image-gallery/styles/css/image-gallery.css';
import ImageGallery from 'react-image-gallery';
import './paquete-detalle-galeria-destino.css';

const GaleriaDestino = (props) => {
  const imagenes = props.images.split(';');
  const sources = [];
  for (let i = 0; i < imagenes.length - 1; i++) {
    sources.push({
      original: imagenes[i],
      thumbnail: imagenes[i],
      sizes: '22',
    });
  }
  return (
    <div className='seccion'>
      <div className='row'>
        <div className='allseasons'>
          <ImageGallery
            items={sources}
            showFullscreenButton={false}
            showPlayButton={false}
            slideInterval={parseInt(2000, 10)}
            showThumbnails={false}
            autoPlay
            startIndex={1}
            lazyLoad={false}
            infinite
            showIndex
            showNav
            slideDuration={parseInt(450, 10)}
            additionalClass='app-image-gallery'
          />
        </div>
      </div>
    </div>
  );
};
export default GaleriaDestino;
